import React, { useState, useRef } from "react";
import ChatMessageInputView from "./ChatMessageInputView";
import ChatMessageKit, { ChatMessageEnums } from "../../data/ChatMessageKit";

export default function ChatMessageInput({
  messageCollection,
  mutedList,
  type,
  createVideoRoom,
  videoBtn,
  filter,
  setFilter,
  event,
  page,
  urlParams,
  isCorporateAgent,
  options = {},
  eventUserAvailabilityList,
  onMessageSubmit = () => {},
}) {
  // const DEBUG = false;
  const me = messageCollection?.getMe();
  const [message, setMessage] = useState("");
  const [shiftIsPressed, setShiftIsPressed] = useState(false);
  const messageInput = useRef(null);

  const MAX_TEXT = 280;

  function handleOnSubmit(e) {
    e.preventDefault();
    const messageOptions = {
      ...options,
    };

    messageCollection?.create(message, messageOptions);

    onMessageSubmit();

    if (!isCorporateAgent && type === "corporate") {
      ChatMessageKit.setCorporateChatIsTrashed({
        ...urlParams,
        isTrashed: false,
      });
    }
    handleClearMessage();
  }

  function handleOnChange(e) {
    if (!userIsMuted()) {
      if (e.target.innerText.length <= MAX_TEXT) {
        setMessage(e.target.innerText);
      }
    }
  }

  function handleClearMessage() {
    setMessage("");
    messageInput.current.innerText = "";
  }

  function handleOnKeyDown(e) {
    if (
      e.target.innerText.length > MAX_TEXT &&
      e.key !== "Backspace" &&
      e.key !== "ArrowUp" &&
      e.key !== "ArrowRight" &&
      e.key !== "ArrowDown" &&
      e.key !== "ArrowLeft"
    ) {
      e.preventDefault();
    }
    
    if (e.key === "Shift") setShiftIsPressed(true);

    if (e.key === "Enter" && !shiftIsPressed) {
      handleOnSubmit(e);
    }
  }

  function handleOnKeyUp(e) {
    if (e.key === "Shift") setShiftIsPressed(false);
  }

  function handleOnPaste(e) {
    e.preventDefault();
    const pastedText = (e.clipboardData || window.clipboardData).getData('text');
    const plainText = pastedText.replace(/<[^>]*>/g, '');
    document.execCommand('inserttext', false, plainText);
  }

  function userIsMuted() {
    const list = mutedList || {};
    const isMuted = Object.entries(list).some((event_user) => {
      const [eventUserId, muted] = event_user;

      return muted && messageCollection?.getMe()?.id == eventUserId;
    });

    return isMuted;
  }

  async function generateMessages(count) {
    for (let i = 0; i < count; i++) {
      messageCollection?.create(`Test message #${i + 1}`);

      await new Promise((resolve) =>
        setTimeout(() => {
          resolve(null);
        }, 200)
      );
    }
  }

  return (
    <ChatMessageInputView
      me={me}
      isModerator={me.isModerator}
      type={type}
      createVideoRoom={createVideoRoom}
      videoBtn={videoBtn}
      handleOnSubmit={handleOnSubmit}
      handleOnChange={handleOnChange}
      handleOnPaste={handleOnPaste}
      message={message}
      filter={filter}
      setFilter={setFilter}
      event={event}
      page={page}
      urlParams={urlParams}
      messageInput={messageInput}
      handleOnKeyDown={handleOnKeyDown}
      handleOnKeyUp={handleOnKeyUp}
      userIsMuted={userIsMuted()}
      generateMessages={generateMessages}
      handleClearMessage={handleClearMessage}
      isCorporateAgent={isCorporateAgent}
      eventUserAvailabilityList={eventUserAvailabilityList}
    />
  );
}
